
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/mapbox-gl-js',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/mapbox-gl-js/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/api/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-api" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_api.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/api/events/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-api-events" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_api_events.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/api/geography/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-api-geography" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_api_geography.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/api/handlers/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-api-handlers" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_api_handlers.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/api/map/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-api-map" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_api_map.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/api/markers/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-api-markers" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_api_markers.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/api/properties/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-api-properties" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_api_properties.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/api/sources/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-api-sources" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_api_sources.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/3d-buildings/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-3d-buildings" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_3d-buildings.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/3d-extrusion-floorplan/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-3d-extrusion-floorplan" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_3d-extrusion-floorplan.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-3d-model-threebox/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-3d-model-threebox" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-3d-model-threebox.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-3d-model/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-3d-model" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-3d-model.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-a-marker/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-a-marker" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-a-marker.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-fog/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-fog" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-fog.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-image-animated/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-image-animated" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-image-animated.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-image-generated/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-image-generated" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-image-generated.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-image-missing-generated/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-image-missing-generated" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-image-missing-generated.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-image-stretchable/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-image-stretchable" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-image-stretchable.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-image/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-image" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-image.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/add-terrain/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-add-terrain" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_add-terrain.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/adjust-layer-opacity/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-adjust-layer-opacity" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_adjust-layer-opacity.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/animate-a-line/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-animate-a-line" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_animate-a-line.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/animate-ant-path/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-animate-ant-path" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_animate-ant-path.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/animate-camera-around-point/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-animate-camera-around-point" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_animate-camera-around-point.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/animate-images/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-animate-images" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_animate-images.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/animate-marker/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-animate-marker" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_animate-marker.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/animate-point-along-line/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-animate-point-along-line" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_animate-point-along-line.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/animate-point-along-route/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-animate-point-along-route" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_animate-point-along-route.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/attribution-position/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-attribution-position" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_attribution-position.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/camera-animation/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-camera-animation" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_camera-animation.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/canvas-source/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-canvas-source" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_canvas-source.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/center-on-feature/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-center-on-feature" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_center-on-feature.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/center-on-symbol/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-center-on-symbol" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_center-on-symbol.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/change-building-color-based-on-zoom-level/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-change-building-color-based-on-zoom-level" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_change-building-color-based-on-zoom-level.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/change-case-of-labels/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-change-case-of-labels" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_change-case-of-labels.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/check-for-support/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-check-for-support" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_check-for-support.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/cluster-html/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-cluster-html" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_cluster-html.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/cluster/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-cluster" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_cluster.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/color-switcher/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-color-switcher" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_color-switcher.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/cooperative-gestures/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-cooperative-gestures" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_cooperative-gestures.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/custom-marker-icons/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-custom-marker-icons" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_custom-marker-icons.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/custom-style-id/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-custom-style-id" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_custom-style-id.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/custom-style-layer/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-custom-style-layer" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_custom-style-layer.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/dancing-buildings/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-dancing-buildings" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_dancing-buildings.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/data-driven-circle-colors/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-data-driven-circle-colors" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_data-driven-circle-colors.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/data-driven-lines/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-data-driven-lines" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_data-driven-lines.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/data-join/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-data-join" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_data-join.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/disable-rotation/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-disable-rotation" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_disable-rotation.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/disable-scroll-zoom/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-disable-scroll-zoom" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_disable-scroll-zoom.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/display-and-style-rich-text-labels/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-display-and-style-rich-text-labels" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_display-and-style-rich-text-labels.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/drag-a-marker/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-drag-a-marker" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_drag-a-marker.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/drag-a-point/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-drag-a-point" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_drag-a-point.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/elevation-along-line/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-elevation-along-line" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_elevation-along-line.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/external-geojson/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-external-geojson" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_external-geojson.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/fallback-image/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-fallback-image" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_fallback-image.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/featuresat/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-featuresat" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_featuresat.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/fill-opacity-transition/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-fill-opacity-transition" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_fill-opacity-transition.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/fill-pattern/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-fill-pattern" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_fill-pattern.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/filter-features-within-map-view/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-filter-features-within-map-view" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_filter-features-within-map-view.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/filter-markers-by-input/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-filter-markers-by-input" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_filter-markers-by-input.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/filter-markers/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-filter-markers" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_filter-markers.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/filter-symbols-expression/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-filter-symbols-expression" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_filter-symbols-expression.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/fitbounds/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-fitbounds" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_fitbounds.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/flyto-options/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-flyto-options" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_flyto-options.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/flyto/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-flyto" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_flyto.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/forward-geocode-custom-data/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-forward-geocode-custom-data" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_forward-geocode-custom-data.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/free-camera-path/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-free-camera-path" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_free-camera-path.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/free-camera-point/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-free-camera-point" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_free-camera-point.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/fullscreen/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-fullscreen" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_fullscreen.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/game-controls/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-game-controls" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_game-controls.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/geojson-layer-in-stack/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-geojson-layer-in-stack" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_geojson-layer-in-stack.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/geojson-line/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-geojson-line" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_geojson-line.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/geojson-markers/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-geojson-markers" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_geojson-markers.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/geojson-polygon/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-geojson-polygon" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_geojson-polygon.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/georeference-imagery/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-georeference-imagery" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_georeference-imagery.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/globe-spin/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-globe-spin" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_globe-spin.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/heatmap-layer/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-heatmap-layer" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_heatmap-layer.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/heatmap/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-heatmap" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_heatmap.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/hillshade/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-hillshade" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_hillshade.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/hover-styles/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-hover-styles" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_hover-styles.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/image-on-a-map/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-image-on-a-map" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_image-on-a-map.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/interactive-false/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-interactive-false" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_interactive-false.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/jump-to/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-jump-to" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_jump-to.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/language-switch/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-language-switch" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_language-switch.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/line-across-180th-meridian/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-line-across-180th-meridian" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_line-across-180th-meridian.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/line-gradient/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-line-gradient" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_line-gradient.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/live-geojson/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-live-geojson" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_live-geojson.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/live-update-feature/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-live-update-feature" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_live-update-feature.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/local-ideographs/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-local-ideographs" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_local-ideographs.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/locate-user/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-locate-user" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_locate-user.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/map-projection/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-map-projection" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_map-projection.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/map-tiles/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-map-tiles" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_map-tiles.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-compare/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-compare" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-compare.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-directions/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-directions" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-directions.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-draw/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-draw" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-draw.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-geocoder-accept-coordinates/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-geocoder-accept-coordinates" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-geocoder-accept-coordinates.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-geocoder-custom-render/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-geocoder-custom-render" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-geocoder-custom-render.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-geocoder-limit-region/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-geocoder-limit-region" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-geocoder-limit-region.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-geocoder-no-map/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-geocoder-no-map" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-geocoder-no-map.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-geocoder-outside-the-map/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-geocoder-outside-the-map" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-geocoder-outside-the-map.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-geocoder-with-flyto/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-geocoder-with-flyto" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-geocoder-with-flyto.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-geocoder-with-language/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-geocoder-with-language" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-geocoder-with-language.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-geocoder/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-geocoder" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-geocoder.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-rtl-text/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-rtl-text" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-rtl-text.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mapbox-gl-supported/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mapbox-gl-supported" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mapbox-gl-supported.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/marker-from-geocode/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-marker-from-geocode" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_marker-from-geocode.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/marker-horizon-aligned/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-marker-horizon-aligned" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_marker-horizon-aligned.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/marker-popup/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-marker-popup" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_marker-popup.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/measure/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-measure" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_measure.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/mouse-position/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-mouse-position" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_mouse-position.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/multiple-geometries/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-multiple-geometries" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_multiple-geometries.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/navigation-scale/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-navigation-scale" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_navigation-scale.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/navigation/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-navigation" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_navigation.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/offset-vanishing-point-with-padding/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-offset-vanishing-point-with-padding" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_offset-vanishing-point-with-padding.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/pitch-and-distance-from-center/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-pitch-and-distance-from-center" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_pitch-and-distance-from-center.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/playback-locations/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-playback-locations" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_playback-locations.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/point-from-geocoder-result/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-point-from-geocoder-result" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_point-from-geocoder-result.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/polygon-popup-on-click/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-polygon-popup-on-click" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_polygon-popup-on-click.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/popup-on-click/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-popup-on-click" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_popup-on-click.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/popup-on-hover/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-popup-on-hover" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_popup-on-hover.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/popup/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-popup" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_popup.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/projections/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-projections" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_projections.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/query-similar-features/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-query-similar-features" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_query-similar-features.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/query-terrain-elevation/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-query-terrain-elevation" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_query-terrain-elevation.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/queryrenderedfeatures-around-point/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-queryrenderedfeatures-around-point" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_queryrenderedfeatures-around-point.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/queryrenderedfeatures/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-queryrenderedfeatures" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_queryrenderedfeatures.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/render-world-copies/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-render-world-copies" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_render-world-copies.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/restrict-bounds/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-restrict-bounds" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_restrict-bounds.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/satellite-map/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-satellite-map" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_satellite-map.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/scroll-fly-to/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-scroll-fly-to" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_scroll-fly-to.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/set-perspective/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-set-perspective" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_set-perspective.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/set-popup/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-set-popup" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_set-popup.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/setstyle/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-setstyle" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_setstyle.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/simple-map/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-simple-map" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_simple-map.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/style-switch/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-style-switch" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_style-switch.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/switch-symbol-style-pitch/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-switch-symbol-style-pitch" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_switch-symbol-style-pitch.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/third-party/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-third-party" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_third-party.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/timeline-animation/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-timeline-animation" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_timeline-animation.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/toggle-interaction-handlers/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-toggle-interaction-handlers" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_toggle-interaction-handlers.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/toggle-layers/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-toggle-layers" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_toggle-layers.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/toggle-worldviews/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-toggle-worldviews" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_toggle-worldviews.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/updating-choropleth/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-updating-choropleth" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_updating-choropleth.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/using-box-queryrenderedfeatures/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-using-box-queryrenderedfeatures" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_using-box-queryrenderedfeatures.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/using-featuresin/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-using-featuresin" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_using-featuresin.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/variable-label-placement/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-variable-label-placement" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_variable-label-placement.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/vector-source/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-vector-source" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_vector-source.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/video-on-a-map/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-video-on-a-map" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_video-on-a-map.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/visualize-population-density/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-visualize-population-density" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_visualize-population-density.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/within-expressions/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-within-expressions" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_within-expressions.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/wms/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-wms" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_wms.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/example/zoomto-linestring/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-example-zoomto-linestring" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_example_zoomto-linestring.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/examples/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-examples" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_examples.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/guides/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-guides" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_guides.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/guides/browsers-and-testing/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-guides-browsers-and-testing" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_guides_browsers-and-testing.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/guides/globe/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-guides-globe" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_guides_globe.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/guides/install/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-guides-install" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_guides_install.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/guides/migrate-to-v2/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-guides-migrate-to-v2" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_guides_migrate-to-v2.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-guides-pricing" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_guides_pricing.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/guides/projections/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-guides-projections" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_guides_projections.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/overview/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-overview" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_overview.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/plugins/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-plugins" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_plugins.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/expressions/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-expressions" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_expressions.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/fog/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-fog" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_fog.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/glyphs/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-glyphs" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_glyphs.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/layers/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-layers" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_layers.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/light/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-light" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_light.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/other/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-other" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_other.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/projection/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-projection" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_projection.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/root/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-root" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_root.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/sources/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-sources" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_sources.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/sprite/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-sprite" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_sprite.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/terrain/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-terrain" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_terrain.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/transition/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-transition" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_transition.js'
            ),
            
            
          },{
            path: '/mapbox-gl-js/style-spec/types/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-gl-js-style-spec-types" */
              '/work/mapbox-gl-js-docs/_batfish_tmp/_mapbox-gl-js_style-spec_types.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };